<template>

  <b-container fluid>
    <div class="pt-5">
      <b-jumbotron class="bg-none" :header="header" :lead="message">
        <router-link :to="{ name: 'home' }"><v-icon name="home"></v-icon> Back to Home</router-link>
      </b-jumbotron>
    </div>
  </b-container>

</template>
<script>
import { getStatus } from '@/helpers/navigation';

export default {
  name: 'Error',
  props: {
    errorCode: {
      type: Number,
      default: 404,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    header() {
      return `Error ${this.errorCode}`;
    },
    message() {
      switch (this.errorCode) {
        case 404: {
          return this.errorMessage || 'Page not found';
        }
        default:
          return this.errorMessage || getStatus(this.errorCode) || '';
      }
    },
  },
};
</script>
